import { render, staticRenderFns } from "./BlockContentMobile.vue?vue&type=template&id=7d69e64a&scoped=true&"
import script from "./BlockContentMobile.vue?vue&type=script&lang=js&"
export * from "./BlockContentMobile.vue?vue&type=script&lang=js&"
import style0 from "./BlockContentMobile.vue?vue&type=style&index=0&id=7d69e64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d69e64a",
  null
  
)

export default component.exports